import React from 'react';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {EditorPanel, EditorColumn} from '../editor-components';
import ActiveUserList from './active-user-list';
import PendingUserList from './pending-user-list';
import UserCreationDialog from './user-creation-dialog';

export default class UserList extends ReactFireComponent {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      showNewUserDialog: false
    }
    this.toggleNewUserDialog = this.toggleNewUserDialog.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the active user list in
    * the firebase database.
    */
  componentWillMount(){
    this.bindAsArray(`/users`, 'users');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the active user list
    * in the firebase database.
    */
  componentWillUnmount() {
    this.unbind('users');
  }
  toggleNewUserDialog() {
    this.setState({showNewUserDialog: !this.state.showNewUserDialog});
  }
  render() {
    const claimedEmails = this.state.users.map(user => user.email);
    return (
      <div>
        <button className="btn btn-success" onClick={this.toggleNewUserDialog}>
          <FontAwesome name="plus"/>
          Add New User
        </button>
        <UserCreationDialog
          show={this.state.showNewUserDialog}
          onExit={this.toggleNewUserDialog}
          claimedEmails={claimedEmails}/>
        <div className="info-panel">
          The list on the left is currently active users
          and thier role on the platform.  The list on
          the right is invited users who have yet to log in.
          You can send a user a new login link by clicking
          the email icon <FontAwesome name="envelope"/>,
          edit their profile by clicking the edit
          icon <FontAwesome name="edit"/>, or remove
          their account with the delete icon
          <FontAwesome name="times"/>.
        </div>
        <EditorPanel>
          <EditorColumn>
            <ActiveUserList users={this.state.users} />
          </EditorColumn>
          <EditorColumn>
            <PendingUserList/>
          </EditorColumn>
        </EditorPanel>
      </div>
    )
  }
}

UserList.propTypes = {}



// WEBPACK FOOTER //
// ./src/user-list/user-list.js